import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../api";
import { RootState } from "../../../redux/rootReducer";
import { fetchShippingMethod } from "../../../redux/shippingMethodSlice";
import ShippingMethodForm from "./ShippingMethodForm";
import ShippingMethodTable from "./ShippingMethodTable";


function Shipping() {
    const api = useApi()
    const dispatch = useDispatch()
    
    const { results } = useSelector((state:RootState)=>state.shippingMethod)
  
    const [isOpenShippingMethod, setIsOpenShippingMethod] = useState<boolean>(false)

    const getEligibleShippingMethods = () => {
      dispatch(fetchShippingMethod() as any)
    }

    useEffect(()=>{
      getEligibleShippingMethods()
    }, [dispatch])
  

  return (
    <>
      <div>
        <h3>Shipping</h3>
        <button
          className="my-2 float-right bg-primary-400 py-2 px-5 w-full md:w-[200px] text-white rounded-md hover:bg-primary-500 transition-all duration-150 ease-linear"
          onClick={() => setIsOpenShippingMethod(true)}
        >
          Add Shipping Method
        </button>

        <div className="w-full overflow-x-auto">
          <ShippingMethodTable data={results}/>
        </div>

        {isOpenShippingMethod && <ShippingMethodForm isOpen={isOpenShippingMethod} onClose={()=>setIsOpenShippingMethod(!isOpenShippingMethod)}/>}
      
      </div>
    </>
  );
}

export default Shipping;
